import React from 'react';
import { MessagingWrapper as MessagingProvider } from './MessagingWrapper';

export const MessagingApp = ({ children }: { children?: React.ReactNode }) => {
  return <MessagingProvider>{children}</MessagingProvider>;
};
